module.exports = __webpack_public_path__ + "images/puzzle/Skeleton/PNG/Piece01.8270bcd5acf6837d6d63c8814bbfa874.png";